module.exports = __webpack_public_path__ + "img/pollola_sisalta8.73c1304d.jpg";